import React, { useState } from "react";
import Header from "../../components/header";
import History from "../../components/history";
import { Row, Col, Form, Tabs, Tab, Button } from "react-bootstrap";
import { useCookies } from "react-cookie";
import InventarioInicial from "../InventarioInicial";
import MovimientosSnapshot from "../MovimientosSnapshot";
import InventarioFinal from "../InventarioFinal";
import styles from "./InventarioAnimales.module.css";
import Resultados from "../Resultados";

const InventarioAnimales = (props) => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [cookie] = useCookies(["kUserSession"]);
  const [loadingResumen, setLoadingResumen] = useState(false);
  const [loadingResultados, setLoadingResultados] = useState(false);

  const prepareHeaders = () => ({
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
      api_key: "k-randa",
      access_token: cookie.kUserSession.data.access_token,
    },
  });

  const generarResumen = (e) => {
    e.preventDefault();
    setLoadingResumen(true);
    const farm = cookie.kUserSession.data["farm"];
    let url =
      process.env.REACT_APP_API_URL +
      `inventario_animales/resumen/excel?id_estancia=${farm.id}&periodo=${year}`;
    fetch(url, prepareHeaders())
      .then((response) => {
        const filename =
          response.headers.get("content-disposition")?.split("filename=")[1] ||
          `resumen_final_${year}.xls`;
        response.blob().then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
          setLoadingResumen(false);
        });
      })
      .catch((err) => {
        console.error(err);
        setLoadingResumen(false);
      });
  };

  const generarResultados = (e) => {
    e.preventDefault();
    setLoadingResultados(true);
    const farm = cookie.kUserSession.data["farm"];
    let url =
      process.env.REACT_APP_API_URL +
      `inventario_animales/resultados/excel?id_estancia=${farm.id}&periodo=${year}`;
    fetch(url, prepareHeaders())
      .then((response) => {
        const filename =
          response.headers.get("content-disposition")?.split("filename=")[1] ||
          `resultados_${year}.xls`;
        response.blob().then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
          setLoadingResultados(false);
        });
      })
      .catch((err) => {
        console.error(err);
        setLoadingResultados(false);
      });
  };

  const history = [
    { name: "Inicio", path: "/" },
    { name: "Movimientos de hacienda", path: "/movimientos" },
  ];

  return (
    <>
      <Header history={props.history} />
      <section className={styles.body}>
        <Row>
          <Col>
            <History
              items={history}
              current={"Inventario de animales"}
              history={props.history}
            />
          </Col>
        </Row>
        <Row>
          <Col md={2} xs={12}>
            <section className={styles.side}>
              <Form className={styles.searchForm}>
                <Form.Group>
                  <Form.Label htmlFor="periodo" className={styles.label}>
                    Periodo
                  </Form.Label>
                  <Form.Control
                    id="periodo"
                    className="karanda-input"
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    type="number"
                  />
                </Form.Group>
                <Button
                  className="karanda-btn"
                  style={{ marginTop: "0.5rem" }}
                  onClick={generarResumen}
                  disabled={loadingResumen}
                >
                  {loadingResumen ? "Generando..." : "Descargar excel"}
                </Button>
                &nbsp;
                &nbsp;
                <Button
                  className="karanda-btn"
                  style={{ marginTop: "0.5rem" }}
                  onClick={generarResultados}
                  disabled={loadingResultados}
                >
                  {loadingResultados ? "Generando..." : "Resultados"}
                </Button>
              </Form>
            </section>
          </Col>
          <Col>
            <section className={styles.content}>
              <h1 className={styles.title}>Inventario de animales</h1>
              <Tabs defaultActiveKey="inicial" variant="pills" >
                <Tab eventKey="inicial" title="Inventario Inicial" >
                  <div style={{ marginTop: "1rem" }}>
                    <InventarioInicial embedded year={year} />
                  </div>
                </Tab>
                <Tab eventKey="movimientos" title="Movimientos">
                  <div style={{ marginTop: "1rem" }}>
                    <MovimientosSnapshot embedded year={year} />
                  </div>
                </Tab>
                <Tab eventKey="final" title="Inventario Final">
                  <div style={{ marginTop: "1rem" }}>
                    <InventarioFinal embedded year={year} />
                  </div>
                </Tab>
                <Tab eventKey="resultados" title="Resultados">
                  <div style={{ marginTop: "1rem" }}>
                    <Resultados embedded year={year} />
                  </div>
                </Tab>
              </Tabs>
            </section>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default InventarioAnimales;

